import { render, staticRenderFns } from "./editbase.vue?vue&type=template&id=da064414&"
import script from "./editbase.vue?vue&type=script&lang=js&"
export * from "./editbase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports